exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hero{background-color:#263238;height:50rem;padding:3rem}.hero *{color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/hero/hero.scss
// module id = 432
// module chunks = 0